var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.icon,{tag:"component",staticClass:"gs-transaction-status-icon",class:['gs-transaction-status-icon--' + _vm.tone, { 'is-checking': _vm.icon === 'LoaderIcon' }],attrs:{"size":"16","stroke-width":"1.75","aria-hidden":"true","focusable":"false"}})
}
var staticRenderFns = []

export { render, staticRenderFns }